<div class="card__header">
  <h2>Criar usuário a partir de um já existente</h2>
  <span class="close-btn material-icons" (click)="closeSideNav()"> close </span>
</div>

<section class="user-add">
  <div class="user-add__form__container">
    @if (createLogonLoading) {
      <div class="user-add__form__spinner">
        <seds-loaders-spinner></seds-loaders-spinner>
      </div>
    }
    <form class="user-add__form" [formGroup]="searchCloneableLogonForm">
      @if (
        (cloneableLogon$ | async)?.error || (clonedLogon$ | async)?.error
        ) {
        <pl-alert
          color="error"
          display="block"
          >
          <span header>{{ errorMessage?.title }}</span>
          <span content>
            {{ errorMessage?.description }}
          </span>
        </pl-alert>
      }

      <div class="user-add__form__search">
        @if (!(cloneableLogon$ | async)?.logon) {
          <seds-form-field-text
            class="user-add__form__search__input"
            label="Pesquise pelo logon do usuário que servirá como espelho"
            [warningColor]="true"
            >
            <input matInput formControlName="logon" id="search" name="search" />
          </seds-form-field-text>
        }
        @if ((cloneableLogon$ | async)?.logon) {
          <seds-form-field-text
            class="user-add__form__search__input"
            label="Pesquise pelo logon do usuário que servirá como espelho"
            >
            <input
              matInput
              disabled
            [value]="
              (cloneableLogon$ | async)?.logon?.logon +
              ' | ' +
              (cloneableLogon$ | async)?.logon?.fullName
            "
              id="search"
              name="search"
              />
          </seds-form-field-text>
        }
        @if (!(cloneableLogon$ | async)?.logon && !searchLoading) {
          <seds-basic-button
            class="search-button"
            type="button"
            [disabled]="!searchCloneableLogonForm.valid"
            title="Buscar"
            (click)="searchCloneableLogonData()"
          ></seds-basic-button>
        }
        @if ((cloneableLogon$ | async)?.logon && !searchLoading) {
          <seds-basic-button
            class="search-button"
            type="button"
            title="Limpar"
            (click)="cleanCloneableLogonData()"
          ></seds-basic-button>
        }
        @if (searchLoading) {
          <seds-basic-button
            class="search-button"
            type="button"
            [loading]="true"
            [disabled]="true"
          ></seds-basic-button>
        }
      </div>

      @if (!(cloneableLogon$ | async)?.logon) {
        <pl-alert
          class="information"
          color="warning"
          display="block"
          >
          <span header>Orientações</span>
          <span content>
            - O novo usuário terá acesso aos mesmos produtos que o usuário usado
            como espelho.<br />
            - O usuário usado como espelho deve estar com o status ativo.<br />
            - Não é possível buscar o usuário usado como espelho pelo nome.
          </span>
        </pl-alert>
      }
    </form>

    @if ((cloneableLogon$ | async)?.logon) {
      <form
        class="user-add__form"
        [formGroup]="createClonedLogonForm"
        >
        <div class="user-add__form__fields">
          <seds-form-field-text
            class="user-add__form__fields__input"
            label="Nome do usuário"
            [warningColor]="true"
            >
            <input matInput id="name" name="name" formControlName="name" />
          </seds-form-field-text>
          <seds-form-field-text
            class="user-add__form__search__input"
            label="E-mail"
            [warningColor]="true"
            >
            <input
              matInput
              id="email"
              name="email"
              type="email"
              formControlName="email"
              />
          </seds-form-field-text>
          <seds-form-field-text
            class="user-add__form__search__input"
            label="Identificação do logon"
            [warningColor]="true"
            >
            <input
              matInput
              id="nameLogon"
              name="nameLogon"
              formControlName="nameLogon"
              />
          </seds-form-field-text>
          @if (
            createClonedLogonForm.controls['nameLogon'].valid ||
            createClonedLogonForm.controls['nameLogon'].pristine
            ) {
            <span
              class="user-add__form__search__input__tip"
              >Esse campo será utilizado como identificação na sua fatura, deve possuir entre 8 e 20 caracteres. <br /> Exemplo: Logon Financeiro.
            </span>
          }
        </div>
      </form>
    }
  </div>
</section>
<pl-action-footer>
  <div class="action-footer">
    <div
      class="action-footer__back"
      (click)="closeSideNav()"
      launchLabel="Voltar"
      launchSection="Clique"
      launchSiteSection="PortalDeLogons"
      plAnalyticsButton
      >
      <span class="material-icons">arrow_back_ios</span>
      <span>Voltar</span>
    </div>

    @if ((cloneableLogon$ | async)?.logon) {
      <seds-basic-button
        (click)="addUser()"
        [disabled]="!createClonedLogonForm.valid || createLogonLoading"
        type="button"
        title="Criar usuário"
        launchLabel="Criar usuário"
        launchSection="Clique"
        launchSiteSection="PortalDeLogons"
        plAnalyticsButton
        >
      </seds-basic-button>
    }
  </div>
</pl-action-footer>
